export default "__VITE_ASSET__g_WD5bzz__";